import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { LayoutComponent } from './layout/layout.component';
import { AddProviderComponent } from './modules/clusters/pages/add-provider/add-provider.component';
import { CheckConfigComponent } from './modules/dashboard/pages/check-config/check-config.component';
import { MainComponent } from "./layouts/main/main.component";
import { AddProviderComponent as AddProviderDashComponent } from './modules/dashboard/pages/add-provider/add-provider.component';
import { AppDashboardComponent } from './modules/app/app/app.component';
import { AppDetailsComponent } from './modules/app/app-details/app-details.component';
import { AppLogComponent } from './modules/app/app-log/app-log.component';
import { RegistryComponent } from './modules/app/registry/registry.component';
import { DomainComponent } from './modules/app/domain/domain.component';
import { CheckSubscriptionGuard } from './shared/guards/check-subscription';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { ApplicationComponent } from './modules/deploy/pages/delivery/application/application.component';
import { DetailApplicationComponent } from './modules/deploy/pages/delivery/application/detail-application/detail-application.component';
import { DeploymentComponent } from './modules/deploy/pages/delivery/deployment/deployment.component';
import { FormDeploymentComponent } from './modules/deploy/pages/delivery/deployment/form-deployment/form-deployment.component';
import { DetailDeploymentComponent } from './modules/deploy/pages/delivery/deployment/detail-deployment/detail-deployment.component';
import { LoginApimComponent } from './modules/secure/pages/iam/login-apim/login-apim.component';
import { CustomTabComponent } from './modules/organization/custom-tab/custom-tab.component';
import { tokenHasExpired } from './shared/guards/refresh-token';

const routes: Routes = [
  { path: 'check-config/:orgId', component: CheckConfigComponent },
  {
    path: 'add-provider',
    component: AddProviderComponent,
    canActivate: [tokenHasExpired, CheckSubscriptionGuard],
  },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: MainComponent,
    children: [
      // { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'unauthorized/:type',
        component: UnauthorizedComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },
      {
        path: 'dashboard/add-provider',
        component: AddProviderDashComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },
      {
        path: 'app-details',
        component: AppDetailsComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },
      {
        path: 'app-log',
        component: AppLogComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },

      {
        path: 'apps',
        component: AppDashboardComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },
      {
        path: 'login-apim',
        component: LoginApimComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },
      {
        path: 'registry',
        component: RegistryComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },
      {
        path: 'domain',
        component: DomainComponent,
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
      },

      {
        path: 'deliver',
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
        children: [
          {
            path: '',
            component: ApplicationComponent,
            data: { name: 'list-applications' },
          },
          {
            path: ':id',
            component: DetailApplicationComponent,
          },
        ],
      },

      {
        path: 'deploy',
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
        children: [
          {
            path: '',
            component: DeploymentComponent,
            data: { name: 'list-deployments' },
          },
          {
            path: 'create',
            component: FormDeploymentComponent,
          },
          {
            path: 'edit/:id',
            component: FormDeploymentComponent,
          },
          {
            path: 'detail/:id',
            component: DetailDeploymentComponent,
          },
        ],
      },

      {
        path: 'dashboard',
        canActivate: [CheckSubscriptionGuard, tokenHasExpired],
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'clusters',
        canActivate: [CheckSubscriptionGuard, tokenHasExpired],
        loadChildren: () =>
          import('./modules/clusters/clusters.module').then(
            (m) => m.ClustersModule
          ),
      },
      {
        path: 'onboard',
        canActivate: [tokenHasExpired, CheckSubscriptionGuard],
        loadChildren: () =>
          import('./modules/onboard/onboard.module').then(
            (m) => m.OnboardModule
          ),
        data: { activeId: '1' },
      },
      {
        path: 'delivery',
        canActivate: [CheckSubscriptionGuard, tokenHasExpired],
        loadChildren: () =>
          import('./modules/deploy/deploy.module').then((m) => m.DeployModule),
        data: { activeId: '2' },
      },
      {
        path: 'members',
        canActivate: [CheckSubscriptionGuard, tokenHasExpired],
        loadChildren: () =>
          import('./modules/secure/secure.module').then((m) => m.SecureModule),
        data: { activeId: '3' },
      },
      {
        path: 'parameters',
        canActivate: [CheckSubscriptionGuard, tokenHasExpired],
        loadChildren: () =>
          import('./modules/parameters/parameters.module').then(
            (m) => m.ParametersModule
          ),
        data: { activeId: '4' },
      },
      {
        path: 'migration',
        canActivate: [CheckSubscriptionGuard, tokenHasExpired],
        loadChildren: () =>
          import('./modules/migration/migration.module').then(
            (m) => m.MigrationModule
          ),
      },
      // { path: '**',   redirectTo: '/dashboard', pathMatch: 'full' },

      {
        path: 'organizations',
        canActivate: [CheckSubscriptionGuard, tokenHasExpired],
        children: [
          {
            path: 'list',
            component: CustomTabComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
